import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M13 1a2 2 0 011.92 1.43c3.17.97 5.68 3.48 6.65 6.65A2 2 0 0123 11v2a2 2 0 01-1.43 1.92 10.02 10.02 0 01-6.65 6.65A2 2 0 0113 23h-2a2 2 0 01-1.92-1.43 10.02 10.02 0 01-6.65-6.65A2 2 0 011 13v-2a2 2 0 011.43-1.92 10.02 10.02 0 016.65-6.65A2 2 0 0111 1h2zm.79 16.58a10.053 10.053 0 01-3.58 0l-2.68 2.03c2.813.533 6.127.533 8.94 0l-2.68-2.03zM4.39 7.53c-.533 2.813-.533 6.127 0 8.94l2.03-2.68a10.05 10.05 0 010-3.58L4.39 7.53zm15.22 0l-2.03 2.68a10.053 10.053 0 010 3.58l2.03 2.68c.533-2.813.533-6.127 0-8.94zM12 8a4 4 0 100 8 4 4 0 000-8zm4.47-3.61c-2.813-.533-6.127-.533-8.94 0l2.69 2.03a10.05 10.05 0 013.58 0l2.67-2.03z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
